import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import PaySalaryContainer from '../../containers/salary/paySalary.container'
import UserSelectorContainer from '../../containers/layout/userSelector.container'
import { Translation } from 'react-i18next'
import { scrollToTop } from '../../utils/scrollTo'
import store from '../../store'
import { useDispatch } from 'react-redux'
import { discountIsNotUsed } from '../../actions'
import SalaryRowComponent from './salaryRow.component'
import SortableTable from '../../utils/sortableTable'
import DateTimeFormat from '../../utils/DateTimeFormat'
import { convertNameToState } from '../../utils/invoice.utils'
import Button from '@material-ui/core/Button'
import './PrintButton.css'
/**
 * @author  Pragya Gupta
 */

class NewSalaryComponent extends React.Component {
  componentDidMount() {
    if (this.props.userType == 2) {
      this.props.getAdminUsersList()
    }

    this.props.updateTaxCard()
    this.props.getSalariesStart(this.props.selectedUser)
    this.props.loadProfileStart()
    this.props.getUserCompanyUpdateInfo()
    scrollToTop()
  }

  render() {
    return <Salary {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      padding: '0 10px'
    }
  }
})

const Salary = ({
  salaryRows,
  userType,
  closeSalaryPayError,
  accountStatus,
  allSalaries
}) => {
  // KAS-385 Referral program bugs
  const dispatch = useDispatch()
  React.useEffect(() => {
    if (
      salaryRows.length >= 5 &&
      (accountStatus ===
        'Recommended email is not activated the referral code' ||
        accountStatus === 'Recommended email is activated the referral code')
    ) {
      dispatch(discountIsNotUsed())
    }
  }, [salaryRows, accountStatus])
  //
  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="row">
              {userType == 2 && <UserSelectorContainer />}
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <h1>{t('salaryCompo.h1')}</h1>
              </div>
            </div>
            <div className="row"></div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-heading">
                      <h3 className="panel-title">{t('salaryCompo.h3')}</h3>
                    </div>
                    <div className="panel-body pd-0">
                      <SortableTable
                        data={allSalaries}
                        createRowComponent={createSalaryRow}
                        headerCells={salaryCells}
                        enableFilters={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="pull-right" style={{ paddingRight: '15px' }}>
                <Button
                  variant="contained"
                  onClick={() => window.print()}
                  className="printButton"
                >
                  {t('salaryCompo.btn')}
                </Button>
              </div>
            </div>
            <div className="row">
              <div className="paySalary">
                <PaySalaryContainer />
              </div>
            </div>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={store.getState().salary.salaryPayError}
              autoHideDuration={4000}
              onClose={() => {
                closeSalaryPayError()
              }}
            >
              <MySnackbarContentWrapper
                onClose={() => {
                  closeSalaryPayError()
                }}
                variant="error"
                message={t('salaryCompo.salaryPayError')}
              />
            </Snackbar>
          </div>
        )
      }}
    </Translation>
  )
}

const salaryCells = [
  {
    id: 'created',
    label: 'salaryCompo.table',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    filter: {
      type: 'dateFrom'
    }
  },
  {
    id: 'toDate',
    label: 'toDate',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px',
      display: 'none'
    },
    filter: {
      type: 'dateTo'
    }
  },
  {
    id: 'invoices',
    label: 'salaryCompo.table1',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'sumWithTax',
    label: 'salaryCompo.table8',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'gross_salary',
    label: 'salaryCompo.table2',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  },
  {
    id: 'take_home_pay',
    label: 'salaryCompo.table3',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'expenses_cost',
    label: 'salaryCompo.table4',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'reimbursment_cost',
    label: 'salaryCompo.table5',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile'
  },
  {
    id: 'status',
    label: 'salaryCompo.table6',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    },
    className: 'hide-mobile',
    filter: {
      type: 'select',
      labelConverter: convertNameToState
    }
  },
  {
    id: 'actions',
    label: 'salaryCompo.table7',
    isSortable: false,
    padding: 'normal',
    style: {
      paddingLeft: '16px'
    }
  }
]

const createSalaryRow = (el, index) => {
  return (
    <SalaryRowComponent
      index={index}
      key={el.id}
      date={new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(el.created))}
      invoice_id={el.invoices}
      invoice_sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.sumWithTax)}
      gross_sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.gross_salary)}
      net_sum={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.take_home_pay)}
      allowance_cost={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.expenses_cost)}
      expense_cost={new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(el.reimbursment_cost)}
      status={convertNameToState(el.status)}
      id={el.id}
      invoice_uuid={el.invoice_uuid}
    />
  )
}

NewSalaryComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewSalaryComponent)
